<template>
  <div class="page project-page">


      <div class="project-header">

        <div class="p-meta">
          <h1><i class="icon icon-projects"></i>Projekt <span class="notbold" v-if="project">{{project.data.name}}</span></h1>
         
         <div class="actions">
             <a v-on:click="share_it"><i class="icon icon-share"></i><span>Teilen</span></a>
<!--              <a v-on:click="deleteProject"><i class="icon icon-plus" ></i><span>Projekt löschen</span></a> -->
         </div>
         
        </div>
      </div>

    <div class="app-overlay share-overlay" v-if="openOverlayShare">
        <div class="app-overlay-inner">
          <div class="app-overlay-close" v-on:click=" openOverlayShare = false">&times;</div>
            <div class="overlay-header">
              <h2>Teilen</h2>
            </div>
            <div class="overlay-body">
              <share :sharingUrl="sharingUrl" :sharingDesc="sharingDesc"></share>
            </div>
        </div>
    </div>


      <div class="project-box">
    
<!--
           <div class="project-details">
              <div class="project-products" v-for="(product, i) in project.data.products" :key="i">
               <span class="p-counter">{{project.data.products.length}}</span>
              </div>
           </div>
-->
           
           
           
          <div class="product-list">
                        
              <div class="product" v-for="(product, i) in proproducts" :key="i" v-if="project">
                <div class="product-image"><img :src=" config.appUrl + product.attributes.images[0].sizes.small" loading="lazy" width="600"></div>
                <div class="overlay-artno">
                    <router-link :to="{ name: 'ProductPage', params: { articlenumber: product.articlenumber }}">{{product.articlenumber}}</router-link>
                </div>
                <div class="overlay-details">
                    <router-link :to="{ name: 'ProductPage', params: { articlenumber: product.articlenumber }}">ansehen</router-link>
                </div>
                
              </div>
          </div>
           
           
        
      </div>
          

    <div class="app-overlay projects-overlay" v-if="openOverlayProjects">
        <div class="app-overlay-inner">
          <div class="app-overlay-close" v-on:click=" openOverlayProjects = false">&times;</div>
            <div class="overlay-header">
             <h2>Projekt hinzufügen</h2>
            </div>
            <div class="overlay-body">
              <add-project :articlenumber="articlenumber" @closeOverlay="openOverlayProjects = false"></add-project>
            </div>
        </div>
    </div>



  </div>
</template>
<script>
import config from '../_config/config';
import addProject from '../components/addProject';
import Share from '../components/Share';

export default {
    name: 'ProjectPage',
    components: {
        addProject,
        Share
    },
    
    data: function(){
      return {
        config: null,
           openOverlayProjects: false,
           openOverlayShare: false,
           sharingDesc: ""
         }
    },
    
    methods: {

      getDateFormatted(da){
        var options = { weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' }
        var d = new Date(da)
        return d.toLocaleDateString('de-DE', options);
      },
      deleteProject(){
        console.log('deleteProject');
        },
      share_it(){
        this.openOverlayShare = !this.openOverlayShare;
      },
      
    },
    created: function(){
      this.config = config
      this.$store.dispatch('projects/getOne', { projectid: this.projectid  });
    },
    mounted: function(){},
    computed: {
        user () {
            return this.$store.state.authentication.user
        },
        projectid() {
      // We will see what `params` is shortly
          return this.$route.params.projectid
        },
        
        project() {
            console.log( this.$store.state.projects )
            return this.$store.state.projects.inview.item;
          },
          
       proproducts(){
         if(this.project)
         return this.$store.state.products.all.filter( ( item ) => { return this.project.data.products.includes( item.articlenumber ) } );
       },
          
        sharingUrl(){
            //console.log( this.$route )
            return this.config.appUrl + this.$route.fullPath
          }        
    }
}  
</script>
<style scoped>
  
  
  
  .project-page { position: relative; padding: 9rem 0 9.88888em 0; height: 100%; min-height: 100vh; }

  .project-header { padding: 0.93333em; }

  .project-box { padding: 0 /* 1.33333em 0 0.9333em */; margin: -0.33333em 0; }
  .project-box .projects-list { padding: 0 0 1.4333em 0;  }
  .project-box .projects-list .project { padding: 0.7333em 0.73333em; margin: 0 0 0.53333em 0; background: rgba(255,255,255,0.1); border-radius: 1px; cursor: pointer; 
    transition: background 0.3s;
  }  
  .project-box .projects-list .project:hover { background: rgba(255,255,255,0.2); }
  .p-counter { font-size: 0.9rem; background: rgba(255,255,255,0.3); border-radius: 0.9rem; padding: 0.333em 0.7333em; margin: 0 0.5333em; }

  .project-page .product-list { display: flex; flex-wrap: wrap; outline: 0 solid green; margin-right: 0px; padding: 0.7333em;   }
  .project-page .product-list .product { flex: 1 1 33.333%; max-width: 33.3333%; position: relative; z-index: 1; padding: 0.222em; margin: 0;  transform: scale(1.001); transition:all 0.3s ease; box-shadow: 0; }
  .project-page .product-list .product img { display: block; width: 100%; max-width: 100%; margin: 0; padding: 0; }

  @media screen and ( min-width: 40em) {
    .project-page { display: block; } 
    .project-page .product-list { padding: 0 0.73333em; /* margin-right: 19rem;  */}
    .project-page .product-list .product { flex: 0 1 25%; }
  }
  
  @media screen and ( min-width: 64.0633em) {
    .project-page .product-list .product { flex: 0 1 20%; }
  }

  @media screen and ( min-width: 80em) {  
     .project-page .product-list .product { flex: 0 1 16.666%; }
  }
  
  .overlay-artno { position: absolute; top: auto; bottom: -1em; left: 0; right: 0;  opacity: 0; transform: translate(0,30px); transition: transform 0.3s, opacity 0.3s ease;  }
  .overlay-artno a { 
    display: block; background: rgba(0,0,0,0.7)  ;
    border-radius: 0; padding: 0.222em 0.43333em 0.3333em; text-decoration: none; font-size: 0.7rem; text-align: center; 
  }
  
  
  .overlay-details { position: absolute; top: 50%; margin-top: -1.20rem; right: 0; left: 0; text-align: center; }
  .overlay-details a { display: block; padding:0.0511em 0.633333em; margin: 0 auto; 
    background: rgba(0,0,0,0.7) url(/img/icons-white/search.svg) center center no-repeat; background-size: 1.5rem; text-indent: -9999px; 
    width: 2.5rem; height: 2.5rem;
    border-radius: 2.5rem; 
    text-decoration: none; 
    transform: scale(0.5);
    opacity: 0;
    transition: transform 0.3s, opacity 0.3s ease; 
    font-size: 0.9rem }



  .project-page .product-list .fav-preview { position: absolute; top: 0.3333rem; right: 0.3333rem; cursor: pointer; } 
  .project-page .product-list .fav-preview i { transform: scale(0.6); transition: transform 0.3s; }
  .project-page .product-list .fav-preview:hover i { transform: scale(0.7); }
  .project-page .product-list .fav-preview span { display: none; }



  .project-page .product-list .product:hover { z-index: 500; }

  .project-page .product-list .product:hover .overlay-artno { transform: translate(0,0);  opacity: 1; }
  .project-page .product-list .product:hover .overlay-details a { transform: scale(1); opacity: 1; }
  .project-page .product-list .product:hover { transform: scale(1.1); background: rgba(0,0,0,0.6) }
  .project-page .product-list .product:hover img { box-shadow: 0 0 15px rgba(0,0,0,0.9); }
  
  .notbold { font-weight: normal !important; }
  
</style>